import { render, staticRenderFns } from "./totp_code.vue?vue&type=template&id=97b7551e"
import script from "./totp_code.vue?vue&type=script&lang=js"
export * from "./totp_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports